import gql from 'graphql-tag';

const ORDER_INFO_CLIENT = gql`
  query GetOrderInfo($ordno: ID!) {
    orderInfo(ordno: $ordno) @client {
      isAdmin
      success
      nameOrder
      ordno
      reserveDate
      isEditable
      productInfo {
        id
        cakeName
        backgroundImagePath
        imageWidth
        imageHeight
        isCompleted
        s3FilePath
        sno
        items {
          id
          sno
          type
          title
          editable
          contents
          fontStyle {
            family
            size
            textAlign
            limitStyle
            lineHeightArray {
              subject
              value
            }
          }
          contents
          addStyle
          pos {
            left
            top
            width
            addPosCss
            zindex
          }
          imageInfo {
            src
            originWidth
            originHeight
            shape
            blur
            middleTagArray {
              type
              style
              src
            }
          }
          sort
        }
      }
    }
  }
`;

const ORDER_INFO_REMOTE = gql`
  query GetOrderInfo($ordno: ID!) {
    orderInfo(ordno: $ordno) {
      isAdmin
      success
      message
      nameOrder
      ordno
      orddt
      reserveDate
      isEditable
      productInfo {
        id
        cakeName
        backgroundImagePath
        imageWidth
        imageHeight
        isCompleted
        s3FilePath
        sno
        items {
          id
          sno
          type
          title
          editable
          contents
          fontStyle {
            family
            size
            textAlign
            limitStyle
            lineHeightArray {
              subject
              value
            }
          }
          contents
          addStyle
          pos {
            left
            top
            width
            addPosCss
            zindex
          }
          imageInfo {
            src
            originWidth
            originHeight
            shape
            blur
            middleTagArray {
              type
              style
              src
            }
          }
          sort
        }
      }
    }
  }
`;

const REFETCH_PRODUCT_INFO = gql`
  query refetchProductInfo(
    $ordno: ID!
    $productId: ID!
    $lookupHistory: Boolean!
    $sno: String
  ) {
    refetchProductInfo(
      ordno: $ordno
      productId: $productId
      lookupHistory: $lookupHistory
      sno: $sno
    ) {
      success
      message
      nameOrder
      ordno
      orddt
      isEditable
      productInfo {
        id
        cakeName
        backgroundImagePath
        imageWidth
        imageHeight
        isCompleted
        s3FilePath
        sno
        items {
          id
          sno
          type
          title
          editable
          contents
          fontStyle {
            family
            size
            textAlign
            limitStyle
            lineHeightArray {
              subject
              value
            }
          }
          contents
          addStyle
          pos {
            left
            top
            width
            addPosCss
            zindex
          }
          imageInfo {
            src
            originWidth
            originHeight
            shape
            blur
            middleTagArray {
              type
              style
              src
            }
          }
          sort
        }
      }
    }
  }
`;

// 앱정보를 가져오는 쿼리
const APP_SETTING = gql`
  query AppSetting {
    app @client {
      drawerOpen
      currentEditProductId
      ordno
      passwordCheck
      browser
      currentSno
    }
  }
`;

export {
  ORDER_INFO_CLIENT,
  APP_SETTING,
  ORDER_INFO_REMOTE,
  REFETCH_PRODUCT_INFO,
};



// WEBPACK FOOTER //
// ./src/components/query/query.ts